import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=c1f2d53a&scoped=true"
import script from "./ordersList.vue?vue&type=script&lang=js"
export * from "./ordersList.vue?vue&type=script&lang=js"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=c1f2d53a&scoped=true&lang=css"
import style1 from "./ordersList.vue?vue&type=style&index=1&id=c1f2d53a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f2d53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f2d53a')) {
      api.createRecord('c1f2d53a', component.options)
    } else {
      api.reload('c1f2d53a', component.options)
    }
    module.hot.accept("./ordersList.vue?vue&type=template&id=c1f2d53a&scoped=true", function () {
      api.rerender('c1f2d53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/ordersList.vue"
export default component.exports